export default __webpack_public_path__ + "static/media/Ficha Técnica - Limão Concentrado.2b0533fb.pdf";